import React, { useEffect, useRef } from 'react'

const FloatingParticles = ({ count = 20, colors = ['#ffffff'] }) => {
    const canvasRef = useRef(null)

    useEffect(() => {
        const canvas = canvasRef.current
        if (!canvas) return

        const ctx = canvas.getContext('2d')
        let animationFrameId
        let particles = []

        const resizeCanvas = () => {
            canvas.width = window.innerWidth
            canvas.height = window.innerHeight
        }

        const createParticle = () => ({
            x: Math.random() * canvas.width,
            y: canvas.height + Math.random() * 100,
            size: Math.random() * 3 + 1,
            speedY: Math.random() * 0.5 + 0.2,
            speedX: (Math.random() - 0.5) * 0.2,
            opacity: Math.random() * 0.5 + 0.1,
            color: colors[Math.floor(Math.random() * colors.length)]
        })

        const initParticles = () => {
            particles = []
            for (let i = 0; i < count; i++) {
                const p = createParticle()
                p.y = Math.random() * canvas.height // Distribute initially
                particles.push(p)
            }
        }

        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height)

            particles.forEach((p, index) => {
                p.y -= p.speedY
                p.x += p.speedX

                ctx.beginPath()
                ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2)
                ctx.fillStyle = p.color
                ctx.globalAlpha = p.opacity
                ctx.fill()

                // Reset if off screen
                if (p.y < -50) {
                    particles[index] = createParticle()
                }
            })

            animationFrameId = requestAnimationFrame(animate)
        }

        window.addEventListener('resize', resizeCanvas)
        resizeCanvas()
        initParticles()
        animate()

        return () => {
            window.removeEventListener('resize', resizeCanvas)
            cancelAnimationFrame(animationFrameId)
        }
    }, [count, colors])

    return (
        <canvas
            ref={canvasRef}
            className="absolute inset-0 pointer-events-none z-0"
        />
    )
}

export default FloatingParticles
